/**
 * @file GoogleReviews.jsx
 * @description Google Reviews section using Elfsight widget
 */

import React, { useEffect } from 'react';

const GoogleReviews = () => {
  useEffect(() => {
    // Load Elfsight platform script
    const script = document.createElement('script');
    script.src = 'https://static.elfsight.com/platform/platform.js';
    script.async = true;
    script.dataset.useServiceCore = true;
    script.defer = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup script on unmount
      if (document.body.contains(script)) {
        document.body.removeChild(script);
      }
    };
  }, []);

  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 animate-fade-in-up">
          <h2 className="text-4xl md:text-5xl font-display font-bold text-gray-900 mb-4">
            What Our Customers Say
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">
            Read reviews from our satisfied customers across London
          </p>
        </div>

        {/* Elfsight Google Reviews Widget */}
        <div className="animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          <div 
            className="elfsight-app-cc93f516-3793-468c-8e44-acda7c5a4bf0" 
            data-elfsight-app-lazy
          ></div>
        </div>
      </div>
    </section>
  );
};

export default GoogleReviews;
